import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { GetCohortMembersOutputDto } from '../../../models/user-cohort/dto/user-cohort.dto';

export const GET_COHORT_MEMBERS_QUERY_KEY = (
  cohortId: string,
  take?: number,
  after?: string,
) => ['cohort-members', cohortId, take, after];

export function useGetCohortMembers(
  cohortId?: string,
  options: { take?: number; after?: string } = {},
) {
  const apiClient = useApiClient();

  return useQuery<GetCohortMembersOutputDto>({
    enabled: Boolean(cohortId),
    queryKey: GET_COHORT_MEMBERS_QUERY_KEY(
      cohortId!,
      options.take,
      options.after,
    ),
    queryFn: async (): Promise<GetCohortMembersOutputDto> => {
      const params = new URLSearchParams();
      if (options.take) params.append('take', options.take.toString());
      if (options.after) params.append('after', options.after);

      const response = await apiClient.fetchApi<
        GetCohortMembersOutputDto,
        {}
      >({
        method: 'GET',
        endpoint: `cohorts/${cohortId}/members${params.toString() ? '?' + params.toString() : ''}`,
      });
      return response;
    },
  });
}
